import apollo from 'apollo';
import { AsyncActionHandler } from 'action-handler';

import { hasGalleryGrantQuery } from 'queries';

const stateProp = 'galleryGrant';

export default new AsyncActionHandler({
  name: 'fetch_has_gallery_grant',
  stateProp,
  defaultState: {
    galleryGrant: {
      userHasGrant: false,
      complete: false
    }
  },
  handler() {
    return async () => {
      const { data } = await apollo.query({
        query: hasGalleryGrantQuery,
        fetchPolicy: 'network-only'
      });

      return {
        hasGalleryGrant: data.hasGalleryGrant
      };
    };
  },
  reduce(_, { hasGalleryGrant }) {
    return {
      [this.stateProp]: {
        userHasGrant: hasGalleryGrant,
        complete: true
      }
    };
  }
});
